
document.addEventListener('DOMContentLoaded', () => {
  const tabContainer = document.querySelector('.tabbed-navigation');
  const contentContainer = document.querySelector('.tabbed-content');

  const initializeTabs = () => {
    const tabs = document.querySelectorAll('.tabbed-navigation > *');
    const contents = document.querySelectorAll('.tabbed-content > *');

    // Initially hide all content elements
    contents.forEach((content, index) => {
      content.style.display = index === 0 ? 'block' : 'none';
      if(index == 0){
        tabs[index].classList.toggle('active');
        content.classList.add('active');
      }
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        // Hide all contents
        contents.forEach(content => {
          content.style.display = 'none'
          content.classList.remove('active');
        });

        // Show the content corresponding to the clicked tab
        contents[index].style.display = 'block';
        contents[index].classList.add('active');

        // Update active style on tabs
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
      });
    });
  };

  // Initial setup
  initializeTabs();

  // Observer to detect changes in the tab or content structure for editor
  const observer = new MutationObserver(() => {
    initializeTabs(); // Reinitialize tabs if there's a change
  });

  // Observe both the tab and content containers for child changes
  observer.observe(tabContainer, { childList: true });
});
